import { apiClient } from '../_helpers';

export const notificationService = {
  getAll,
  recipeAccessInvite,
  recipeAccessRequest,
  recipePublishRequest,
  recipeShare,
  collectionAccessInvite,
  collectionAccessRequest,
  deleteNotification,
  respondToNotification
};

function getAll() {
  return apiClient('notifications/')
  .get()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function deleteNotification(notification) {
  return apiClient(`notifications/${notification.id}`)
  .delete()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function recipeAccessRequest(request) {
  return apiClient(`recipes/${request.recipeId}/request`)
  .post('',`${JSON.stringify(request)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function recipePublishRequest(request) {
  return apiClient(`recipes/${request.recipeId}/publish`)
  .post('',`${JSON.stringify(request)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function recipeAccessInvite(request) {
  return apiClient(`recipes/${request.recipeId}/invite`)
  .post('',`${JSON.stringify(request)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function recipeShare(request) {
  return apiClient(`recipes/${request.recipeId}/share`)
  .post('',`${JSON.stringify(request)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function collectionAccessRequest(request) {
  return apiClient(`collections/${request.entityId}/request`)
  .post('',`${JSON.stringify(request)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function collectionAccessInvite(request) {
  return apiClient(`collections/${request.entityId}/invite`)
  .post('',`${JSON.stringify(request)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function respondToNotification(request) {
  return apiClient(`notifications/${request.notificationId}`)
  .put('',`${JSON.stringify(request)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}